<form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>add</mat-icon>
      Add Carousel Item
    </h1>
  </section>
  <section mat-dialog-content>
    <mat-form-field>
      <mat-label>Listing ID</mat-label>
      <input formControlName="listingId" matInput />
    </mat-form-field>
    @if (isFakeCat) {
      <div>
        <mat-form-field>
          <mat-label>Start Date</mat-label>
          <input
            formControlName="start_date"
            matInput
            required
            [matDatepicker]="startDatepicker"
            />
          <mat-datepicker-toggle
            matSuffix
            [for]="startDatepicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #startDatepicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Listing to replace</mat-label>
          <mat-select formControlName="listing_to_replace">
            @for (item of selectOptions; track item) {
              <mat-option [value]="item.id">
                {{ item.title }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </section>
  <section align="end" mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
      >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      [disabled]="!form.valid"
      mat-button
      matTooltip="Save page."
      type="submit"
      >
      <mat-icon>save</mat-icon>
      Save
    </button>
  </section>
</form>
